import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  CustomPagesHeading,
  StatusSectionPrint,
  SectionMediumDividerPrint,
} from "../RecommendGrant/style";
import PageAccountSummary from "../../../../CommonComponents/PageSummary/PageAccountSummary/PageAccountSummary";
import InfoInline from "./Component/ViewEditSchedules/Components/InfoInline";
import Step1SummaryPrint from "./Component/ViewEditSchedules/Components/Step1SummaryPrint";
import Step2SummaryPrint from "../RecommendGrant/Component/ViewEditSchedules/Components/Step2SummaryPrint";
import PermissionToPublish from "./Component/ViewEditSchedules/Components/PermissionToPublish";

export default class ViewGrantDetailsPrint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAllocationEdit: false,
    };
  }
  render() {
    return (
      <>
        <div className="flex items-baseline mt-10">
          <CustomPagesHeading className="mb-10" letterSpace="0.5px">
            {this.props.scheduleId || this.props.spawnId
              ? `Schedule ID: ${this.props.currentScheduleId}`
              : `Transaction ID: ${this.props.grantId}`}
          </CustomPagesHeading>
        </div>
        <PageAccountSummary
          key="accountName"
          label={this.props.accountName}
          value={this.props.accountNumber}
          dataName="accountName"
        />
        <StatusSectionPrint>
          <InfoInline title="Entered Date:" value={this.props.enteredDate} />
          <InfoInline title="Current Status:" value={this.props.status} />
          {(this.props.status === "Payment issued" ||
            this.props.status === "Payment completed") && (
            <>
              {this.props.checkIssuedDate &&
                this.props.checkIssuedDate !== "Invalid date" && (
                  <InfoInline
                    title="Issued Date:"
                    value={this.props.checkIssuedDate}
                  />
                )}
              {this.props.checkNumber ? (
                 <InfoInline title="Check Number:" value={this.props.checkNumber} />
                ) : (
                  <InfoInline title="Check Number:" value="Electronic" />
                )}
            </>
          )}
        </StatusSectionPrint>
        <SectionMediumDividerPrint smallMarginTop />
        <Step1SummaryPrint
          charityInfo={this.props.charityInfo}
          purposeRecognition={this.props.prProps}
          codeValueMappingData={this.props.codeValueMappingData}
        />
        <SectionMediumDividerPrint smallMarginTop smallMarginBottom />
        <PermissionToPublish publish={this.props.publishName} />
        <SectionMediumDividerPrint smallMarginTop />
        <Step2SummaryPrint
          {...this.props.amountAllocation}
          edit={false}
          data-test='handle-edit'
          handleEdit={() => {
            if (this.props.scheduleType === "recurring") {
              this.setState({ showAllocationEdit: true });
            } else {
              this.props.setEdit();
              this.props.history.push(
                "/grants/activity/edit/allocation-schedule"
              );
            }
          }}
        />
      </>
    );
  }
}

ViewGrantDetailsPrint.propTypes = {
  accountName: PropTypes.string,
  accountNumber: PropTypes.string,
  amountAllocation: PropTypes.shape({
    allShares: PropTypes.bool,
    allSharesAllPools: PropTypes.bool,
    allocationType: PropTypes.string,
    allocations: PropTypes.array,
    amountString: PropTypes.string,
    endDate: PropTypes.string,
    frequency: PropTypes.string,
    paymentType: PropTypes.string,
    recurring: PropTypes.bool,
    startDate: PropTypes.string,
    title: PropTypes.string,
  }),
  charityInfo: PropTypes.shape({
    charityAddress: PropTypes.shape({
      addressLine1: PropTypes.string,
      addressLine2: PropTypes.string,
      addressLine3: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zipCode: PropTypes.string,
    }),
    charityEin: PropTypes.string,
    charityName: PropTypes.string,
    title: PropTypes.string,
  }),
  checkIssuedDate: PropTypes.string,
  checkNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  codeValueMappingData: PropTypes.object,
  currentScheduleId: PropTypes.string,
  enteredDate: PropTypes.string,
  grantId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  history: PropTypes.object,
  prProps: PropTypes.object,
  publishName: PropTypes.bool,
  scheduleId: PropTypes.string,
  scheduleType: PropTypes.string,
  setEdit: PropTypes.object,
  spawnId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  status: PropTypes.string,
};
